var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmxBrandMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 24,
    viewBox: "0 0 49 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#50E2C2",
    d: "m40.027 8-7.987 7.946L40.133 24l7.987-7.947L40.027 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D4F",
    d: "M12.09 3.998 0 16.005 8.05 24l8.065-8.01 8.005-8.04L16.115 0 12.09 3.998"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#594FFE",
    d: "m32.027 0-8.059 8.004-8.008 8.043L23.968 24 40.08 7.999 32.027 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmxBrandMark);
export default __webpack_public_path__ + "static/media/tmx-brand-mark.7192ddab44ae80c6936f2dca1a796e37.svg";
export { ForwardRef as ReactComponent };